import axios from 'axios';

import { publicAxiosHeader, getV2OldRootUrl } from 'common/helpers/apiHelper';

export const getAddressFormat = (countryCode) =>
  axios.get(
    `${getV2OldRootUrl()}/address-format/${countryCode}?version=2`,
    publicAxiosHeader()
  );
